import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './active-toast.styl'

export default class ActiveToast extends Component {
  static propTypes = {
    noBtn: PropTypes.bool,
    toShow: PropTypes.bool,
    onClick: PropTypes.func,
    intlValues: PropTypes.object,
    actionKey: PropTypes.string,
    intlKey: PropTypes.string,
    action: PropTypes.string,
    text: PropTypes.string
  }

  static defaultProps = {
    noBtn: false,
    toShow: false
  }

  renderContent = () => {
    const { intlValues, intlKey, text } = this.props

    if (intlKey) {
      return (
        <FormattedMessage
          id={intlKey}
          defaultMessage={typeof text === 'string' ? text : ''}
          values={intlValues}
        />
      )
    }
    return text
  }

  render() {
    const { action, actionKey, onClick, toShow, noBtn } = this.props
    const classNames = [styles.wrap]

    if (!toShow) {
      return null
    }

    toShow && classNames.push(styles.show)

    return (
      <div className={classNames.join(' ')}>
        <p className={styles.text}>{this.renderContent()}</p>
        {!noBtn && (
          <button type="button" onClick={onClick} className={styles.btn}>
            <FormattedMessage
              id={actionKey}
              defaultMessage={typeof action === 'string' ? action : ''}
            />
          </button>
        )}
      </div>
    )
  }
}
